"use server";

import { auth } from "@/auth";
import { requireRole } from "@/lib/permissions";
import { GRP_ROLE_ADMIN } from "@/lib/grp";
import type { ActionResult } from "@/types/server-action";
import {
  acquireBatchLock,
  releaseBatchLock,
} from "@/lib/core-batch-queue/queue/queue-job";
import { runDraftPurge } from "@/lib/cat/draft-purge-run";
import type { DraftPurgeRunResult } from "@/lib/cat/draft-purge-run";

const LOCK_KEY = "draft-purge";

export async function runDraftPurgeManuallyAction(): Promise<
  ActionResult<DraftPurgeRunResult & { locked?: boolean }>
> {
  try {
    const session = await auth();
    if (!session?.user?.id) {
      return { success: false, message: "Non authentifié." };
    }

    const { authorized } = requireRole(session, [GRP_ROLE_ADMIN]);
    if (!authorized) {
      return { success: false, message: "Accès refusé." };
    }

    const locked = await acquireBatchLock(LOCK_KEY, 30);
    if (!locked) {
      return {
        success: false,
        message: "Purge déjà en cours.",
      };
    }

    try {
      const result = await runDraftPurge({
        metadata: "purge manuelle admin",
      });
      return { success: true, data: result };
    } finally {
      await releaseBatchLock(LOCK_KEY);
    }
  } catch (error) {
    console.error("[runDraftPurgeManuallyAction]", error);
    return { success: false, message: "Une erreur serveur est survenue." };
  }
}
